module.exports = {
	"ha": "bc",
	"id": 5.6,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by PWID Status, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 99.34296977660972,
						"dataLabels": {
							"enabled": true,
							"format": "2268"
						}
					},
					{
						"y": 88.04204993429697,
						"dataLabels": {
							"enabled": true,
							"format": "2010"
						}
					},
					{
						"y": 82.17257993867719,
						"dataLabels": {
							"enabled": true,
							"format": "1876"
						}
					},
					{
						"y": 72.27332457293035,
						"dataLabels": {
							"enabled": true,
							"format": "1650"
						}
					},
					{
						"y": 44.98466929478756,
						"dataLabels": {
							"enabled": true,
							"format": "1027"
						}
					},
					{
						"y": null
					},
					{
						"y": 99.90379064845104,
						"dataLabels": {
							"enabled": true,
							"format": "5192"
						}
					},
					{
						"y": 89.01289205310756,
						"dataLabels": {
							"enabled": true,
							"format": "4626"
						}
					},
					{
						"y": 84.12545699441985,
						"dataLabels": {
							"enabled": true,
							"format": "4372"
						}
					},
					{
						"y": 79.29574754666153,
						"dataLabels": {
							"enabled": true,
							"format": "4121"
						}
					},
					{
						"y": 60.03463536655763,
						"dataLabels": {
							"enabled": true,
							"format": "3120"
						}
					},
					{
						"y": null
					},
					{
						"y": 79.3103448275862,
						"dataLabels": {
							"enabled": true,
							"format": "2415"
						}
					},
					{
						"y": 47.914614121510674,
						"dataLabels": {
							"enabled": true,
							"format": "1459"
						}
					},
					{
						"y": 42.49589490968801,
						"dataLabels": {
							"enabled": true,
							"format": "1294"
						}
					},
					{
						"y": 39.54022988505747,
						"dataLabels": {
							"enabled": true,
							"format": "1204"
						}
					},
					{
						"y": 29.195402298850574,
						"dataLabels": {
							"enabled": true,
							"format": "889"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -0.6570302233902758,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.375661375661373,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.04690831556503,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.75757575757576,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.09620935154897037,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.901386748844377,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.4907047124945985,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.741079597438247,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.29022082018928,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -20.68965517241379,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -39.585921325051764,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.309115832762162,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.955177743431218,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.16279069767442,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=2283"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=5197"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=3045"
			}
		],
		"dataTable": {
			"IDU": [
				2283,
				2268,
				2010,
				1876,
				1650,
				1027
			],
			"Non-IDU": [
				5197,
				5192,
				4626,
				4372,
				4121,
				3120
			],
			"Unknown": [
				3045,
				2415,
				1459,
				1294,
				1204,
				889
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_6.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_6.json
// module id = 171
// module chunks = 0